import {
    AUM_RESPONSE, AUM_RESPONSE_FAIL, GET_BALANCE_SHEET_RESPONSE, GET_BALANCE_SHEET_FAILED,
    GET_BANK_BOOK_RESPONSE, GET_BANK_BOOK_FAILED, GET_BROKER_LEDGER_RESPONSE,
    GET_BROKER_LEDGER_FAILED, GET_CLIENT_INFO_RESPONSE, GET_CLIENT_INFO_FAILED,
    GET_CUSTODIAN_FEES_LEDGER_RESPONSE, GET_CUSTODIAN_FEES_LEDGER_FAILED, GET_EXIT_LOAD_LEDGER_RESPONSE, GET_EXIT_LOAD_LEDGER_FAILED,
    PMS_MANAGEMENT_FEES_LEDGER_RESPONSE, PMS_MANAGEMENT_FEES_LEDGER_FAILED,
    PMS_UP_FRONT_FEES_PAYABLE_LEDGER_RESPONSE, PMS_UP_FRONT_FEES_PAYABLE_LEDGER_FAILED,
    GET_INCOME_EXPENSE_STATEMENT_RESPONSE, GET_INCOME_EXPENSE_STATEMENT_FAILED,
    PMS_MOVEMENT_OF_CORPUS_RESPONSE,PMS_MOVEMENT_OF_CORPUS_FAILED,
    PMS_PERFORMANCE_BASED_FEES_LEDGER_FAILED,PMS_PERFORMANCE_BASED_FEES_LEDGER_RESPONSE,
    GET_LEDGER_ACCOUNT_RESPONSE,GET_LEDGER_ACCOUNT_FAILED,
    PMS_SECURITIES_TRANSACTION_TAX_FAILED,PMS_SECURITIES_TRANSACTION_TAX_RESPONSE,
    PMS_PROFIT_LOSS_FAILED,PMS_PROFIT_LOSS_RESPONSE,
    PMS_TRANSACTION_STATEMENT_REPORT_FAILED,PMS_TRANSACTION_STATEMENT_REPORT_RESPONSE,
    PERFORMANCE_FEES_CALCULATION_RESPONSE,PERFORMANCE_FEES_CALCULATION_FAILED,
    GET_PMS_WELCOME_LETTER_FAILED,GET_PMS_WELCOME_LETTER_RESPONSE,
    GET_MIS_MONTH_FAILED,GET_MIS_MONTH_RESPONSE,
    MIS_REPORTS_FAILED,MIS_REPORTS_RESPONSE,ACC_PER_MERGER_REPORTS_RESPONSE,ACC_PER_MERGER_REPORTS_FAILED,
    ONEPAGER_REPORTS_RESPONSE,ONEPAGER_REPORTS_FAILED,
    GET_INVESTMENT_DISTRIBUTION_STATEMENT_RESPONSE,
    GET_INVESTMENT_DISTRIBUTION_STATEMENT_RESPONSE_FAIL,
    CAGR_REPORT_RESPONSE,
    CAGR_REPORT_FAILED
} from '../types/reports';

const initialState = {
    aum: [],
    getBalanceSheet: [],
    getBankBook: [],
    getBrokerLedger: [],
    getClientInfo: [],
    getCustodianFeesLedger: [],
    getExitLoadLedger: [],
    pmsManagementFees: [],
    pmsUpfrontFeesPayableLedger: [],
    getIncomeExpenseStatement: [],
    getLedgerAccount:[],
    pmsMovementOfCorpus: [],
    pmsPerformanceBasedFeesLedger:[],
    pmsProfitLoss: [],
    pmsSecuritiesTransactionTax: [],
    pmsUpfrontFeesPayableLedger:[],
    performanceFeesCalculation:[],
    getPMSWelcomeLetter:[],
    misMonth:[],
    misReport:[],
    accPerMerger:[],
    onePager:[],
    getInvestmentDistributionStatement: [],
    cagrReport: [],
}

export default function reducer(state = initialState, action) {
    console.log("type", action.type);
    switch (action.type) {
        case AUM_RESPONSE:
            return { ...state, aum: action.payload }
        case AUM_RESPONSE_FAIL:
            return { ...state, aum: action.payload }
        case GET_INVESTMENT_DISTRIBUTION_STATEMENT_RESPONSE:
            return { ...state, getInvestmentDistributionStatement: action.payload }
        case GET_INVESTMENT_DISTRIBUTION_STATEMENT_RESPONSE_FAIL:
            return { ...state, getInvestmentDistributionStatement: action.payload }

        case GET_BALANCE_SHEET_RESPONSE:
            return { ...state, getBalanceSheet: action.payload }
        case GET_BALANCE_SHEET_FAILED:
            return { ...state, getBalanceSheet: action.payload }

        case GET_BANK_BOOK_RESPONSE:
            return { ...state, getBankBook: action.payload }
        case GET_BANK_BOOK_FAILED:
            return { ...state, getBankBook: action.payload }

        case GET_BROKER_LEDGER_RESPONSE:
            return { ...state, getBrokerLedger: action.payload }
        case GET_BROKER_LEDGER_FAILED:
            return { ...state, getBrokerLedger: action.payload }

        case GET_CLIENT_INFO_RESPONSE:
            return { ...state, getClientInfo: action.payload }
        case GET_CLIENT_INFO_FAILED:
            return { ...state, getClientInfo: action.payload }

        case GET_CUSTODIAN_FEES_LEDGER_RESPONSE:
            return { ...state, getCustodianFeesLedger: action.payload }
        case GET_CUSTODIAN_FEES_LEDGER_FAILED:
            return { ...state, getCustodianFeesLedger: action.payload }

        case GET_EXIT_LOAD_LEDGER_RESPONSE:
            return { ...state, getExitLoadLedger: action.payload }
        case GET_EXIT_LOAD_LEDGER_FAILED:
            return { ...state, getExitLoadLedger: action.payload }

        case PMS_MANAGEMENT_FEES_LEDGER_RESPONSE:
            return { ...state, pmsManagementFees: action.payload }
        case PMS_MANAGEMENT_FEES_LEDGER_FAILED:
            return { ...state, pmsManagementFees: action.payload }

        case PMS_UP_FRONT_FEES_PAYABLE_LEDGER_RESPONSE:
            return { ...state, pmsUpfrontFeesPayableLedger: action.payload }
        case PMS_UP_FRONT_FEES_PAYABLE_LEDGER_FAILED:
            return { ...state, pmsUpfrontFeesPayableLedger: action.payload }

        case GET_INCOME_EXPENSE_STATEMENT_RESPONSE:
            return { ...state, getIncomeExpenseStatement: action.payload }
        case GET_INCOME_EXPENSE_STATEMENT_FAILED:
            return { ...state, getIncomeExpenseStatement: action.payload }

        case GET_LEDGER_ACCOUNT_RESPONSE:
            return { ...state, getLedgerAccount: action.payload }
        case GET_LEDGER_ACCOUNT_FAILED:
            return { ...state, getLedgerAccount: action.payload }    
        
        case PMS_MOVEMENT_OF_CORPUS_RESPONSE:
            return { ...state, pmsMovementOfCorpus: action.payload }
        case PMS_MOVEMENT_OF_CORPUS_FAILED:
            return { ...state, pmsMovementOfCorpus: action.payload }    

    

            case PMS_SECURITIES_TRANSACTION_TAX_RESPONSE:
            return { ...state, pmsSecuritiesTransactionTax: action.payload }
        case PMS_SECURITIES_TRANSACTION_TAX_FAILED:
            return { ...state, pmsSecuritiesTransactionTax: action.payload }

        case PMS_PERFORMANCE_BASED_FEES_LEDGER_RESPONSE:
            return { ...state, pmsPerformanceBasedFeesLedger: action.payload }
        case PMS_PERFORMANCE_BASED_FEES_LEDGER_FAILED:
            return { ...state, pmsPerformanceBasedFeesLedger: action.payload }

            case PMS_UP_FRONT_FEES_PAYABLE_LEDGER_RESPONSE:
            return { ...state, pmsUpfrontFeesPayableLedger: action.payload }
        case PMS_UP_FRONT_FEES_PAYABLE_LEDGER_FAILED:
            return { ...state, pmsUpfrontFeesPayableLedger: action.payload }

            case PMS_PROFIT_LOSS_RESPONSE:
            return { ...state, pmsProfitLoss: action.payload }
        case PMS_PROFIT_LOSS_FAILED:
            return { ...state, pmsProfitLoss: action.payload }

            case PERFORMANCE_FEES_CALCULATION_RESPONSE:
            return { ...state, performanceFeesCalculation: action.payload }
        case PERFORMANCE_FEES_CALCULATION_FAILED:
            return { ...state, performanceFeesCalculation: action.payload }

            case GET_PMS_WELCOME_LETTER_RESPONSE:
            return { ...state, getPMSWelcomeLetter: action.payload }
        case GET_PMS_WELCOME_LETTER_FAILED:
            return { ...state, getPMSWelcomeLetter: action.payload }

            case GET_MIS_MONTH_RESPONSE:
            return { ...state, misMonth: action.payload }
        case GET_MIS_MONTH_FAILED:
            return { ...state, misMonth: action.payload }

        case MIS_REPORTS_RESPONSE:
            return { ...state, misReport: action.payload }
        case MIS_REPORTS_FAILED:
            return { ...state, misReport: action.payload }

        case ACC_PER_MERGER_REPORTS_RESPONSE:
            return { ...state, accPerMerger: action.payload }
        case ACC_PER_MERGER_REPORTS_FAILED:
            return { ...state, accPerMerger: action.payload }

        case ONEPAGER_REPORTS_RESPONSE:
            return { ...state, onePager: action.payload }
        case ONEPAGER_REPORTS_FAILED:
            return { ...state, onePager: action.payload }

        case CAGR_REPORT_RESPONSE:
            return { ...state, cagrReport: action.payload }
        case CAGR_REPORT_FAILED:
            return { ...state, cagrReport: action.payload }

        default:
            return state
    }

}
